import React from "react";
import { changeLocale, IntlContextConsumer } from "gatsby-plugin-intl";

const FLAGS = {
  hu: "🇭🇺",
  en: "🇬🇧",
};

const LanguageSwitch = () => {
  return (
    <IntlContextConsumer>
      {({ languages, language: currentLocale }) => {
        const otherLang = languages.find((l) => l !== currentLocale) || (currentLocale === "hu" ? "en" : "hu");
        return (
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              changeLocale(otherLang);
            }}
            className="text-3xl p-1 mt-4 lg:mt-0 bg-transparent border-0 cursor-pointer focus:outline-none"
            title={currentLocale === "hu" ? "Switch to English" : "Váltás magyarra"}
            aria-label={currentLocale === "hu" ? "Switch to English" : "Váltás magyarra"}
          >
            {FLAGS[currentLocale] || currentLocale}
          </button>
        );
      }}
    </IntlContextConsumer>
  );
};

export default LanguageSwitch;
